module.exports = __webpack_public_path__ + "files/62f64dbda4764230454ac755d4999fa5.png";